module.exports = __webpack_public_path__ + "img/anicomgo_rgb-06.76edbdb4.png";